import type { ApiSchemas } from '@provisium/web-api'

import type { RfqDto, RfqLineDto } from './types'

// Тип провода берём из контракта: он генерируется из openapi.json, который печётся из кода
// бэкенда. Уберут или переименуют поле — здесь будет ошибка компиляции, а не тихий undefined.
// camelCase-часть — совместимость со старым бэкендом.
type RfqLineRaw = ApiSchemas['RfqLineDto'] & Partial<RfqLineDto>
export type RfqRaw = ApiSchemas['RfqDto'] &
  Partial<RfqDto> & {
    supplier_contact?: RfqDto['supplierContact']
    lines?: RfqLineRaw[]
  }

const normalizeLine = (raw: RfqLineRaw): RfqLineDto => ({
  id: raw.id ?? 0,
  productTypeId: raw.productTypeId ?? raw.product_type_id ?? 0,
  quantity: Number(raw.quantity ?? 0),
  unit: raw.unit ?? '',
  note: raw.note ?? null,
  sortOrder: raw.sortOrder ?? raw.sort_order ?? 0,
  supplierSku: raw.supplierSku ?? raw.supplier_sku ?? null,
  productName: raw.productName ?? raw.product_name ?? null,
  lineStatus: raw.lineStatus ?? raw.line_status ?? 'active',
})

/** Заявка с провода (snake_case) в вид, с которым работают экраны. */
export const normalizeRfq = (raw: RfqRaw): RfqDto => ({
  id: raw.id ?? 0,
  organizationId: raw.organizationId ?? raw.organization_id ?? 0,
  supplierOrganizationId: raw.supplierOrganizationId ?? raw.supplier_organization_id ?? 0,
  title: raw.title ?? '',
  displayNumber: raw.displayNumber ?? raw.display_number ?? null,
  batchNumber: raw.batchNumber ?? raw.batch_number ?? null,
  partIndex: raw.partIndex ?? raw.part_index ?? null,
  description: raw.description ?? null,
  status: raw.status ?? '',
  createdAt: raw.createdAt ?? raw.created_at ?? new Date(0).toISOString(),
  updatedAt: raw.updatedAt ?? raw.updated_at ?? new Date(0).toISOString(),
  supplierContact: raw.supplierContact ?? raw.supplier_contact ?? null,
  lines: (raw.lines ?? []).map(normalizeLine),
  desiredDeliveryDate: raw.desiredDeliveryDate ?? raw.desired_delivery_date ?? null,
  desiredDeliveryTimeUntil: raw.desiredDeliveryTimeUntil ?? raw.desired_delivery_time_until ?? null,
  deliveryAddress: raw.deliveryAddress ?? raw.delivery_address ?? null,
  supplierDecisionStatus: raw.supplierDecisionStatus ?? raw.supplier_decision_status ?? null,
  rejectionReasonCode: raw.rejectionReasonCode ?? raw.rejection_reason_code ?? null,
  substitutionComment: raw.substitutionComment ?? raw.substitution_comment ?? null,
  restaurantSubstitutionComment:
    raw.restaurantSubstitutionComment ?? raw.restaurant_substitution_comment ?? null,
  customerDisputeComment: raw.customerDisputeComment ?? raw.customer_dispute_comment ?? null,
})
